<svelte:options customElement={{
  tag: 'column-layout',
  shadow: 'none',
  props: {
    columns: { reflect: true, type: 'Number' },
    tabColumns: { reflect: true, type: 'Number', attribute: 'tab-columns' },
    spColumns: { reflect: true, type: 'Number', attribute: 'sp-columns' },
    gap: { reflect: true, type: 'String' },
    gapClass: { reflect: true, type: 'String', attribute: 'gap-class' },
    button: { reflect: true, type: 'Boolean' },
    row: { reflect: true, type: 'Boolean' },
    caption: { reflect: true, type: 'Boolean' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * カラムレイアウト
   * パーツライブラリ準拠の mod-column 構造
   * @prop {number} columns - PCカラム数 (1〜5)
   * @prop {number} tabColumns - タブレットカラム数 (1〜5, 0=PC設定引継)
   * @prop {number} spColumns - SPカラム数 (1〜5, 0=PC設定引継)
  * @prop {string} gap - カラム間ギャップ (例: '32px' / '48px 24px')
  * @prop {string} gapClass - カラムギャップ用クラス (例: '__gap40')
   * @prop {boolean} button - ボタン並び (__button)
   * @prop {boolean} row - 縦並び (__row、button=true時のみ)
   * @prop {boolean} caption - キャプション付き (__caption)
   */
  export let columns = 3;
  export let tabColumns = 0;
  export let spColumns = 1;
  export let gap = '';
  export let gapClass = '';
  export let button = false;
  export let row = false;
  export let caption = false;

  function normalizeGapClass(value) {
    if (!value) return '';
    return value.startsWith('__') ? value : `__${value}`;
  }

  $: wrapClass = [
    'mod-column',
    button ? '__button' : '',
    button && row ? '__row' : '',
    caption ? '__caption' : '',
    normalizeGapClass(gapClass)
  ].filter(Boolean).join(' ');

  $: colClass = `__column_${columns}`;
  $: tabColClass = tabColumns ? `__column_tab_${tabColumns}` : '';
  $: spColClass = spColumns ? `__column_sp_${spColumns}` : '';
  $: itemClass = [colClass, tabColClass, spColClass].filter(Boolean).join(' ');
  $: wrapStyle = gap ? `gap: ${gap};` : '';

  let wrapperEl;

  onMount(() => {
    const host = wrapperEl.parentElement;
    const nodesToMove = [];
    host.childNodes.forEach(node => {
      if (node !== wrapperEl) nodesToMove.push(node);
    });
    nodesToMove.forEach(node => wrapperEl.appendChild(node));
  });
</script>

<div class={wrapClass} style={wrapStyle} data-item-class={itemClass} bind:this={wrapperEl}></div>
